import { PropsWithChildren } from "react"
import { ArticleListType, PureArticleListType } from "@tm/models"
import { useEmptyListParams } from "./useEmptyListParams"
import { ListParamsContext } from "."
import { CombinedListParams } from "../../models"

export type EmptyListParamsProviderProps = PropsWithChildren<{
    listType?: ArticleListType | PureArticleListType
    listSubType?: CombinedListParams["startParams"]["type"]
}>

export function EmptyListParamsProvider({ listType, listSubType, children }: EmptyListParamsProviderProps) {
    const params = useEmptyListParams(listType, listSubType)
    return <ListParamsContext.Provider value={params}>{children}</ListParamsContext.Provider>
}
